export const PAGE_URLS = {
  API_PLAN_CHECKOUT: '/api-plan-checkout',
  API_PRICING: 'https://pictory.ai/pictory-api-pricing',
  PRICING: 'https://pictory.ai/pricing',
};

export const INTEGRATION_URLS = {
  ZAPIER: 'https://pictory.ai/integration-partners/zapier-pictory',
  MAKE: 'https://pictory.ai/integration-partners/make-pictory',
  MCP_SERVER: 'https://pictory.ai/blog/pictory-mcp-server-api',
};
